module.exports = __webpack_public_path__ + "static/media/iconCarBlue.05f1f286.svg";